/* eslint-disable array-callback-return */
/* eslint-disable max-lines */
/* eslint-disable max-len */
import countriesOptions from '@/mixins/countriesOptions';
import formatData from '@/mixins/formatData';
import keyed from '@/mixins/keyed';
import statesOptions from '@/mixins/statesOptions';
import streetTypesOptions from '@/mixins/streetTypesOptions';
import Validations from '@/mixins/validations';

export default {
    /**
     * Nombre del componente
     */
    name: 'PostalDataForm',

    mixins: [countriesOptions, statesOptions, streetTypesOptions, formatData, Validations, keyed],

    /**
     * Datos del componente
     * @return {Object} Data del componente
     */
    data() {
        return {
            keyUpdate: 0,
            collapsed: false,
            postalAddressEdit: null,
            componentKey: 0,
            formatDataRules: () => ({
                key_state: ['state', (value, obj) => Object.assign({}, { key: value }, obj['state'])],
                state: ['state', (value, obj) => Object.assign({}, { name: value }, obj['state'])],
                key_country: [
                    'country',
                    value => (value ? { key: value, name: this.$t(`countries.${value}`) } : null)
                ],
                street_1: ['street_1', value => value],
                street_2: ['street_2', value => value],
                number: ['number', value => value],
                floor: ['floor', value => value],
                door: ['door', value => value],
                city: ['city', value => value],
                postal_code: ['postal_code', value => value]
            })
        };
    },
    props: {
        data: {
            type: Object,
            required: false
        },
        creation: {
            type: Boolean,
            required: false,
            default: false
        },
        existing: {
            type: Boolean,
            required: false,
            default: false
        },
        list: {
            type: Array,
            required: false
        },
        hideActions: {
            type: Boolean,
            required: false,
            default: false
        },
        isModal: {
            type: Boolean,
            required: false,
            default: false
        },
        isContributor: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    methods: {
        // Google Maps Autocomplete function
        async getAddressData(addressData, placeResultData) {
            this.address = addressData;
            const completeAddress = placeResultData.address_components.reverse();
            let state;
            // Clear fields
            this.formattedData.street_1 = undefined;
            this.formattedData.number = undefined;
            this.formattedData.floor = undefined;
            this.formattedData.door = undefined;
            this.formattedData.street_2 = undefined;
            this.formattedData.postal_code = undefined;
            this.formattedData.country = undefined;
            this.formattedData.state = undefined;
            this.formattedData.city = undefined;
            // Assign search result to form fields
            completeAddress.map(ad => {
                if (ad.types.includes('route')) {
                    this.modifiedData['street_1'] = ad.long_name;
                    this.formattedData.street_1 = ad.long_name;
                }
                if (ad.types.includes('street_number')) {
                    this.modifiedData['number'] = ad.long_name;
                    this.formattedData.number = ad.long_name;
                }
                if (ad.types.includes('postal_code')) {
                    this.modifiedData['postal_code'] = ad.long_name;
                    this.formattedData.postal_code = ad.long_name;
                }
                if (ad.types.includes('locality') || ad.types.includes('postal_town')) {
                    this.modifiedData['city'] = ad.long_name;
                    this.formattedData.city = ad.long_name;
                }
                if (ad.types.includes('country')) {
                    if (ad.long_name === 'Spain') {
                        ad.long_name = 'España';
                    }
                    this.countriesOptions.map(co => {
                        if (co.name.includes(ad.long_name)) {
                            this.modifiedData['state'] = undefined;
                            this.modifiedData['key_state'] = undefined;
                            this.modifiedData['key_country'] = co.key;
                            this.formattedData.country = co;
                        }
                    });
                }
                if (ad.types.includes('administrative_area_level_2')) {
                    state = { key: ad.short_name, name: ad.long_name };
                } else if (
                    state === undefined &&
                    (ad.types.includes('administrative_area_level_1') || ad.types.includes('neighborhood'))
                ) {
                    state = { key: ad.short_name, name: ad.long_name };
                } else if (state === undefined && ad.types.includes('postal_town')) {
                    state = { key: ad.short_name, name: ad.long_name };
                }
            });
            await this.loadStatesOptions(this.formattedData.country.key);
            if (state !== undefined) {
                this.statesOptions.map(po => {
                    if (po.name.includes(state.name)) {
                        this.modifiedData['state'] = po.name;
                        this.modifiedData['key_state'] = po.key;
                        this.formattedData.state = po;
                        this.keyUpdate++;
                    }
                });
            }
        },

        /**
         * Función genérica para guardar los elementos editados
         * @param {*} field Campo editado
         * @param {*} val Valor
         */
        setValueEdited(field, val) {
            switch (field) {
                case 'state':
                    this.modifiedData['state'] = val.name;
                    this.modifiedData['key_state'] = val.key;
                    break;
                case 'key_country':
                    this.modifiedData['key_country'] = val.key;
                    // this.formattedData['state'] = null;
                    this.modifiedData['state'] = undefined;
                    this.modifiedData['key_state'] = undefined;
                    this.loadStatesOptions(val.key);
                    break;
                default:
                    this.modifiedData[field] = typeof val === 'object' ? val.key : val;
                    break;
            }
        },

        /**
         * Validate personal data
         * @param {Object} addressData to validate
         * @param {Number} index newIntervener index
         * @param {String} addressType type of address
         * @return {Boolean} valid or not
         */
        validateData() {
            this.cleanErrors();

            const requiredProperties = ['street_1', 'number', 'postal_code', 'city', 'country'];

            return Promise.resolve(true).then(valid => this.validateRequired(requiredProperties, valid));
        },

        /**
         * Return postal data
         * If multiple addresses, add form data to addresses list if it's fulfilled
         * Else (single address) return the form data
         * @return {Array} array of postal addresses
         */
        getPostalData() {
            let existingPostalAddresses = [];
            if (this.list.length) {
                existingPostalAddresses = this.list.slice();
            }
            let postalData;
            if (this.data) {
                postalData = Object.assign({}, this.data, this.modifiedData);
            }
            return postalData ? [...existingPostalAddresses, postalData] : existingPostalAddresses;
        },

        /**
         * @param {Event} e FormEvent
         */
        submitAddress(e) {
            e.preventDefault();
            this.validateData().then(valid => {
                if (!valid) {
                    this.$toast.error(`Dirección postal - error en formulario`, `Revise los campos marcados en rojo.`);
                    return;
                }

                if (this.creation) {
                    this.$emit('saved', Object.assign({}, this.data, this.modifiedData));
                    this.modifiedData = {};
                } else {
                    this.$intervenersService
                        .updateIntervenerAddress(
                            this.data.uuid_intervener,
                            this.data.uuid,
                            Object.assign({}, this.data, this.modifiedData)
                        )
                        .then(res => {
                            this.modifiedData = {};
                            this.$emit('saved', res.data.intervener_address);
                            this.$root.$emit('refresh_intervener');
                            this.$toast.success(`Guardado`, `Datos modificados con éxito.`);
                        })
                        .catch(err => {
                            this.$toast.error(err.name, err.message);
                            this.formatData();
                            this.modifiedData = {};
                        });
                }
            });
        },

        /**
         * Al cancelar la edición se cierra el desplegable
         * @param {*} e Event
         */
        cancelAddress(e) {
            e.preventDefault();
            e.stopPropagation();
            this.postalAddressEdit = false;
            this.$emit('canceled');
        },

        /**
         * @override
         */
        removeAddress(index) {
            this.$emit('removePostalData', index);
        }
    },

    /**
     * @override
     */
    beforeMount() {
        if (this.creation) {
            this.postalAddressEdit = !this.existing;
            this.collapsed = true;
        }

        if (this.data && this.data.key_country) {
            this.loadStatesOptions(this.data.key_country);
        }
    }
};
